var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultSort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.700001 4.20002C0.700001 3.7582 1.05817 3.40002 1.5 3.40002H9.5C9.94183 3.40002 10.3 3.7582 10.3 4.20002C10.3 4.64185 9.94183 5.00002 9.5 5.00002H1.5C1.05817 5.00002 0.700001 4.64185 0.700001 4.20002Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.700001 1.00001C0.700001 0.558184 1.05817 0.200012 1.5 0.200012H11.5C11.9418 0.200012 12.3 0.558184 12.3 1.00001C12.3 1.44184 11.9418 1.80001 11.5 1.80001H1.5C1.05817 1.80001 0.700001 1.44184 0.700001 1.00001Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.700001 7.39998C0.700001 6.95815 1.05817 6.59998 1.5 6.59998H6.5C6.94183 6.59998 7.3 6.95815 7.3 7.39998C7.3 7.8418 6.94183 8.19998 6.5 8.19998H1.5C1.05817 8.19998 0.700001 7.8418 0.700001 7.39998Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultSort);
export default __webpack_public_path__ + "static/media/default-sort.ad969742e601d4020d1688a61d51aef5.svg";
export { ForwardRef as ReactComponent };